import { TableHeaderColumn, TableHeaderContainer } from "./TableHeaderStyles";

interface TableHeaderData {
  name?: string;
  width?: string;
  textAlign?: "left" | "center" | "right"; // Add align to the interface
}

interface TableHeaderProps {
  headerColumns: TableHeaderData[];
  variant?: "filled" | "outline";
  textAlign?: "left" | "center" | "right";
  styles?: React.CSSProperties;
}

const TableHeader = (props: TableHeaderProps) => {
  const { headerColumns, variant = "outline", textAlign = "left", styles } = props;
  return (
    <TableHeaderContainer variant={variant}>
      {headerColumns.map((header, index) => (
        <TableHeaderColumn
          key={index}
          style={{
            width: header?.width || "auto",
            textAlign: header.textAlign || textAlign, // Use header's align if present
            ...styles,
          }}
          variant={variant}
        >
          {header?.name || ""}
        </TableHeaderColumn>
      ))}
    </TableHeaderContainer>
  );
};

export default TableHeader;